import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Interested? Then feel free to contact me!
        </p>
        <p className='footer-subscription-text'>
          I'll get back to you soon as possible
        </p>
        <div className='input-areas'>
          <form>
          <a href='/src/components/pages/Contact.js'>
            <Button buttonStyle='btn--outline' path='/contact'>Contact Me!</Button>
            </a>
          </form>
        </div>
      </section>
 
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              Emre Abush
              <i class="fa-solid fa-terminal fa-bounce"></i>
            </Link>
          </div>
          <small class='website-rights'>EA  © 2021</small>
          <div class='social-icons'>

            <a
              class='social-icon-link instagram'
              href='https://www.instagram.com/emreabush/?hl=en'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </a>
           
            <a
              class='social-icon-link twitter'
              href='https://www.linkedin.com/in/emre-abush-ba2432195'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='LinkedIn'
            >
              <i class='fab fa-linkedin' />
            </a>

            <a
              class='social-icon-link twitter'
              href='https://github.com/emreab'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='LinkedIn'
            >
              <i class="fa-brands fa-github"></i>
            </a>

          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
